import { RESEND_TASK, RESEND_TASK_SUCCESSFUL, RESEND_TASK_FAILED } from './actionTypes';

export const resendTask = (token) => {
    return {
        type: RESEND_TASK,
        payload: { token }
    }
}

export const resendTaskSuccessful = (msg) => {
    return {
        type: RESEND_TASK_SUCCESSFUL,
        payload: msg
    }
}

export const resendTaskFailed = (msg) => {
    return {
        type: RESEND_TASK_FAILED,
        payload: msg
    }
}
